import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectNavigationInfoFragment = { __typename?: 'Project', id: string, name: string, workspaceId: string, mountedStorageStatus?: Types.MountedStorageStatus | null };

export const ProjectNavigationInfo = /*#__PURE__*/ gql`
    fragment ProjectNavigationInfo on Project {
  id
  name
  workspaceId
  mountedStorageStatus
}
    ` as unknown as DocumentNode<ProjectNavigationInfoFragment, unknown>;

        

        
export const useProjectNavigationInfoFragment = (
  input: string | Omit<UseFragmentOptions<ProjectNavigationInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectNavigationInfoFragment>({
    fragment: ProjectNavigationInfo,
    fragmentName: 'ProjectNavigationInfo',
    ...options,
  });
};
  
        